<template>
  <div id="app">
    <b-container fluid>
      <b-row>
        <Hero :section="hero" />
        <Header/>
      </b-row>
    </b-container>
    <b-container>
      <b-container>
        <b-row>
          <b-col>
            <Intro :section="intro" />
            <div class="content">
              <Carousel :section="quality" />
              <Carousel :section="commitment" />
              <Carousel :section="excellence" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <Footer/>
  </div>
</template>

<script>
import Hero from './components/Hero'
import Header from './components/Header'
import Intro from './components/Intro'
import Carousel from './components/Carousel'
import Footer from './components/Footer'
// import HelloWorld from './components/HelloWorld'

export default {
  name: 'App',
  components: {
    Hero,
    Header,
    Intro,
    Carousel,
    Footer
  },
  data () {
    return {
      hero: 'hero',
      header: 'header',
      intro: 'intro',
      quality: 'quality',
      commitment: 'commitment',
      excellence: 'excellence'
    }
  }
}
</script>

<style lang="scss">
// $antiqua: "urw-antiqua",serif;
// $runda: "runda",sans-serif;
//
// // Colors
// $black: #000000;
// $white: #ffffff;
@import './_variables.scss';

#app {
  font: 16px/1.5 $runda;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $black;
  overflow: hidden;
}
h1, h2, h3, h4, h5, h6 {
  font-family: $antiqua;
  font-weight: 900;
  font-style: italic;
}
h2 {
  font-size: 30px;
  span {
    background: $white;
    display: inline-block;
  }
  &.head {
    span {
      padding: 0 10px 0 0;
    }
  }
  &.subhead {
    span {
      padding: 0 0 0 10px;
    }
  }
}
p {
  a {
    font-weight: 700;
  }
}
#hero {
  .carousel-control-prev,
  .carousel-control-next {
    height: 50px;
    bottom: 0px;
    top: inherit;
    width: 44px;
    height: 44px;
    opacity: 1;
    background-size: 22px 22px !important;
    background-position: 50% !important;
    transition: all .3s ease;
    &:hover {
      background-size: 30px 30px !important;
    }
    @media (min-width: 768px) {
      top: 50%;
      margin-top: -22px;
      z-index: 99;
    }
  }
  @media (min-width: 768px) {
    .carousel-control-prev {
      background: url(../static/carousel-prev-white.svg) no-repeat $black;
    }
    .carousel-control-next {
      background: url(../static/carousel-next-white.svg) no-repeat $black;
    }
  }
}
.carousel-control-prev,
.carousel-control-next,
.next,
.prev {
  height: 50px;
  bottom: 0px;
  top: inherit;
  width: 44px;
  height: 44px;
  opacity: 1;
  background-size: 22px 22px !important;
  background-position: 50% !important;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: none;
}
.carousel-control-prev,
.prev {
  background: url(../static/carousel-prev.svg) no-repeat;
}
.carousel-control-next,
.next {
  background: url(../static/carousel-next.svg) no-repeat;
}
.carousel-indicators {
  bottom: 2px;
  li {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    border: 2px solid $black;
    margin-right: 15px;
    margin-left: 15px;
    &.active {
      background: $black;
    }
  }
}
.content section {
  position: relative;
  margin-top: 65vw;
  margin-left: -30px;
  margin-right: -30px;
  padding-left: 30px;
  padding-right: 30px;
  z-index: 1;
  @media (min-width: 768px) {
    margin-top: 0;
    // overflow-y: hidden;
  }
  h2 {
    margin-left: -30px;
    max-width: 280px;
    margin-top: -30vw;
    margin-bottom: 20px;
    @media (min-width: 768px) {
      margin-left: 0;
      max-width: 100%;
      margin-top: 0;
      margin-bottom: 0;
    }
    span {
      display: inline-block;
      padding: 0 10px 10px 0;
      padding: 0 11px 11px 0;
      margin-top: -1px;
      margin-right: -1px;
      position: relative;
      top: 0;
      @media (min-width: 768px) {
        padding: 0 5px 10px;
      }
    }
  }
  &:before {
    position: absolute;
    content: '';
    // top: -100vw;
    top: calc(-100vw + 1px);
    left: 0;
    width: 0;
    height: 0;
    border: 0 solid transparent;
    border-top-width: 100vw;
    border-bottom-width: 0px;
    border-right: 100vw solid;
    @media (min-width: 768px) {
      // top: 0;
      // border: none;
      border: 0 solid transparent;
      border-right-width: 0px;
      border-left-width: 130vw;
      border-bottom: 130vw solid black;
      top: 0;
      left: -130vw;
    }
    @media (min-width: 920px) {
      // top: 0;
      // border: none;
      border: 0 solid transparent;
      border-right-width: 0px;
      border-left-width: 100vw;
      border-bottom: 100vw solid black;
      top: 0;
      left: -100vw;
    }
  }
  .carousel-control-next,
  .next {
    top: 50%;
    margin-top: -44px;
    margin-right: -30px;
  }
  .carousel-control-prev,
  .prev {
    top: 50%;
    margin-top: -44px;
    margin-left: -30px;
  }
  .prev {
    margin-left: -10px;
  }
  .next {
    margin-right: -10px;
  }
  .prev,
  .next {
    margin-top: -25px;
  }
  &:nth-child(even) {
    background: $white;
    color: $black;
    margin-top: 35vw;
    @media (min-width: 768px) {
      margin-top: 0;
    }
    &:before {
      border-right-color: $white;
      @media (min-width: 768px) {
        // top: 0;
        // border: none;
        border: 0 solid transparent;
        // border-right-width: 0px;
        // border-left-width: 100vw;
        // border-bottom: 100vw solid $white;
        top: 0;
        left: -50vw;
        border-left-width: 0px;
        border-right-width: 100vw;
        border-top: 100vw solid $white;
      }
    }
    &:after {
      @media (min-width: 768px) {
        position: absolute;
        content: '';
        top: -110vw;
        // left: calc(100vw - 140px);
        right: -110vw;
        width: 0;
        height: 0;
        border: 0 solid transparent;
        border-right-width: 0px;
        border-left-width: 110vw;
        border-bottom: 110vw solid $white;
      }
    }
    h2 {
      text-align: right;
      margin-left: auto;
      margin-right: -30px;
      border-left: none;
      border-right: 30px solid $black;
      margin-top: -62vw;
      max-width: 310px;
      @media (min-width: 768px) {
        border-right: none;
        margin-right: 0;
        margin-top: 0;
        max-width: 100%;
        display: inline-block;
      }
      span {
        color: $white;
        background: $black;
        border-top: 1px solid $black;
      }
    }
    a {
      color: $black;
      &.carousel-control-prev,
      &.prev {
        background: url(../static/carousel-prev-white.svg) no-repeat $black;
        @media (min-width: 768px) {
          left: 15%;
          // margin-left: -200px;
        }
      }
      &.carousel-control-next,
      &.next {
        background: url(../static/carousel-next-white.svg) no-repeat $black;
        @media (min-width: 768px) {
          right: 15%;
          // margin-right: -200px;
        }
      }
    }
  }
  &:nth-child(odd) {
    background: $black;
    color: $white;
    &:before {
      border-right-color: $black;
    }
    &:after {
      @media (min-width: 768px) {
        position: absolute;
        content: '';
        border-right: 100vw solid $black;
        top: 0;
        right: -100vw;
        height: 100%;
        z-index: -1;
      }
    }
    h2 {
      border-left: 30px solid $white;
      @media (min-width: 768px) {
        border-left: none;
      }
      span {
        color: $black;
        background: $white;
        border-top: 1px solid $white;
      }
    }
    .carousel-indicators li,
    ul.indicators li.indicator {
      border: 2px solid $white;
      background: transparent !important;
      &.active {
        background: $white !important;
      }
    }
    a {
      color: $white;
      &.carousel-control-prev,
      &.prev {
        background: url(../static/carousel-prev.svg) no-repeat $white;
        @media (min-width: 768px) {
          left: 15%;
          // margin-left: -200px;
        }
      }
      &.carousel-control-next,
      &.next {
        background: url(../static/carousel-next.svg) no-repeat $white;
        @media (min-width: 768px) {
          right: 15%;
          // margin-right: -200px;
        }
      }
    }
  }
  &:first-child {
    border-bottom: 50vw solid $black;
    @media (min-width: 768px) {
      border-bottom: none;
    }
  }
  &:last-child {
    z-index: 0;
    @media (min-width: 768px) {
      z-index: 1;
    }
  }
}
.youtube-player {
  position: relative;
  padding-bottom: 56.23%;
  /* Use 75% for 4:3 videos */
  height: 0;
  overflow: hidden;
  max-width: 100%;
  background: $black;
  margin: 5px;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: transparent;
  }
  .thumbnail {
    position: absolute;
    top: 0;
    width: calc(100% - 4px);
    height: 100%;
    img {
      width: 100%;
    }
    &:hover {
      img {
        -webkit-filter: brightness(75%);
      }
      .play {
        height: 80px;
        width: 80px;
        margin-left: -40px;
        margin-top: -40px;
      }
    }
  }
  img {
    bottom: 0;
    display: block;
    left: 0;
    margin: auto;
    max-width: 100%;
    width: 100%;
    position: absolute;
    right: 0;
    top: 0;
    border: none;
    height: auto;
    cursor: pointer;
    -webkit-transition: .4s all;
    -moz-transition: .4s all;
    transition: .4s all;
  }
  .play {
    height: 68px;
    width: 68px;
    left: 50%;
    top: 50%;
    margin-left: -34px;
    margin-top: -34px;
    position: absolute;
    background: url("../static/play.svg") no-repeat;
    transition: all .3s ease;
    cursor: pointer;
    &:hover {
      height: 80px;
      width: 80px;
      margin-left: -40px;
      margin-top: -40px;
    }
  }
}
.carousel-3d-container {
  &.video-loaded {
    .prev {
      margin-left: -25px;
    }
    .next {
      margin-right: -25px;
    }
  }
  .prev,
  .next {
    transition: all .3s ease;
    span {
      display: none;
    }
  }
}
ul.indicators {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 0;
  li.indicator {
    display: inline-block;
    list-style: none;
    margin: 0 10px;
    padding: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 2px solid $black;
    background: $white;
    cursor: pointer;
    &.active {
      background: $black;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue